import SocialLinks from '@atoms/SocialLinks/SocialLinks';
import { IAuthor } from '@models/IAuthor';
import ProfilePictureSizeEnum from '@models/enums/ProfilePictureSizeEnum';
import SizeEnum from '@models/enums/SizeEnum';
import AuthorPanel from '@molecules/AuthorPanel/AuthorPanel';

interface Props {
  readonly author: IAuthor;
}

const AuthorHero = ({ author }: Props) => {
  const { socialLinks = [], socialTitle = '' } = author;

  return (
    <section className="bg-black-100 pb-13 text-black-100 dark:bg-grey-600 dark:text-white">
      <div className="dark container flex flex-wrap pt-9 lg:pt-20">
        <div className="w-full">
          <AuthorPanel
            {...author}
            textSize={SizeEnum.XLarge}
            size={ProfilePictureSizeEnum.Size120}
          />
        </div>
        {!!socialLinks?.length && (
          <div className="mt-10 lg:mt-0 lg:ml-auto">
            <SocialLinks
              textClasses="body-four"
              socialLinks={socialLinks}
              socialTitle={socialTitle}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default AuthorHero;
